import { render } from "./data-privacy.vue?vue&type=template&id=62f8ba10&scoped=true"
import script from "./data-privacy.vue?vue&type=script&lang=js"
export * from "./data-privacy.vue?vue&type=script&lang=js"

import "../../resources/css/settings.scss?vue&type=style&index=0&id=62f8ba10&lang=scss&scoped=true&external"
import "./data-privacy.vue?vue&type=style&index=1&id=62f8ba10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f8ba10"]])

export default __exports__